(function () {
  let root = null;
  let popup = null;
  let scrim = null;
  let els = {};
  let globalBound = false;

  let activeContainer = null;
  let activeInput = null;
  let debounceTimer = null;
  let abortController = null;
  const cachedResults = {};
  let lastQuery = '';
  let scrollPreventHandler = null;

  let defaultTitle = 'Search Fitness Fort';
  let searchUrl = '/search';
  let showVendor = false;
  let showPrice = false;

  function queryElements() {
    root = document.querySelector('[data-ff-search-root]');
    popup = document.querySelector('[data-ff-search-popup]');
    scrim = document.querySelector('[data-ff-search-scrim]');

    if (!root || !popup || !scrim) return false;

    defaultTitle = popup.querySelector('[data-ff-search-results-label]')?.textContent?.trim() || defaultTitle;
    searchUrl = popup.dataset.searchUrl || '/search';
    showVendor = popup.dataset.showVendor === 'true';
    showPrice = popup.dataset.showPrice === 'true';

    els = {
      title: popup.querySelector('[data-ff-search-results-label]'),
      defaultPanel: popup.querySelector('[data-ff-search-default]'),
      livePanel: popup.querySelector('[data-ff-search-live]'),
      loading: popup.querySelector('[data-ff-search-loading]'),
      results: popup.querySelector('[data-ff-search-results]'),
      empty: popup.querySelector('[data-ff-search-empty]'),
      collectionsWrap: popup.querySelector('[data-ff-search-collections-wrap]'),
      productsWrap: popup.querySelector('[data-ff-search-products-wrap]'),
      collectionsList: popup.querySelector('[data-ff-search-collections]'),
      productsList: popup.querySelector('[data-ff-search-products]'),
      viewAll: popup.querySelector('[data-ff-search-view-all]'),
    };

    return true;
  }

  function portalRoot() {
    if (scrim && scrim.parentElement !== document.body) {
      document.body.appendChild(scrim);
    }
    if (root && root.parentElement !== document.body) {
      document.body.appendChild(root);
    }
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function highlightMatch(text, query) {
    const safe = escapeHtml(text);
    if (!query) return safe;
    const re = new RegExp(`(${escapeRegex(query)})`, 'ig');
    return safe.replace(re, '<mark class="ff-search-popup__match">$1</mark>');
  }

  function formatMoney(value) {
    if (window.Shopify?.formatMoney) {
      const cents = Math.round(parseFloat(value) * 100);
      return window.Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
    }
    return value;
  }

  function mergeByUrl(primary, secondary) {
    const merged = [...primary];
    secondary.forEach((item) => {
      if (item.url && !merged.some((existing) => existing.url === item.url)) {
        merged.push(item);
      }
    });
    return merged;
  }

  function lockPageScroll() {
    if (scrollPreventHandler) return;

    scrollPreventHandler = (event) => {
      if (event.target.closest('[data-ff-search-popup]')) return;
      if (event.target.closest('.header__search')) return;
      if (event.target.closest('[data-ff-search-scrim]')) return;
      event.preventDefault();
    };

    window.addEventListener('wheel', scrollPreventHandler, { passive: false });
    window.addEventListener('touchmove', scrollPreventHandler, { passive: false });
  }

  function unlockPageScroll() {
    if (!scrollPreventHandler) return;
    window.removeEventListener('wheel', scrollPreventHandler);
    window.removeEventListener('touchmove', scrollPreventHandler);
    scrollPreventHandler = null;
  }

  function openSearchDetails(container) {
    const details = container?.querySelector('details');
    if (!details || details.hasAttribute('open')) return;

    details.setAttribute('open', '');

    if (typeof trapFocus === 'function') {
      trapFocus(
        details.querySelector('[tabindex="-1"]'),
        details.querySelector('input[type="search"]')
      );
    }
  }

  function closeSearchDetails(container) {
    if (!container) return;

    const modal = container.closest('details-modal');
    const details = container.querySelector('details');
    const summary = container.querySelector('summary');

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(summary);
    }

    if (modal?.onBodyClickEvent) {
      document.body.removeEventListener('click', modal.onBodyClickEvent);
    }

    details?.removeAttribute('open');
  }

  function setPanel(state) {
    const isDefault = state === 'default';

    els.defaultPanel?.classList.toggle('is-hidden', !isDefault);
    els.livePanel?.classList.toggle('is-hidden', isDefault);

    if (!isDefault) {
      els.loading?.classList.toggle('is-hidden', state !== 'loading');
      els.results?.classList.toggle('is-hidden', state !== 'results');
      els.empty?.classList.toggle('is-hidden', state !== 'empty');

      if (els.loading) {
        els.loading.setAttribute('aria-hidden', state !== 'loading' ? 'true' : 'false');
      }
    }
  }

  function showDefaultView() {
    lastQuery = '';
    if (els.collectionsList) els.collectionsList.innerHTML = '';
    if (els.productsList) els.productsList.innerHTML = '';
    if (els.title) els.title.textContent = defaultTitle;
    setPanel('default');
  }

  function getDefaultItems() {
    if (!els.defaultPanel) return { collections: [], products: [] };

    const collections = Array.from(
      els.defaultPanel.querySelectorAll('.ff-search-popup__collection-item')
    ).map((link) => ({
      title: link.querySelector('.ff-search-popup__collection-name')?.textContent?.trim() || '',
      url: link.getAttribute('href') || '',
      image: link.querySelector('img')?.getAttribute('src') || '',
      products_count: link.querySelector('.ff-search-popup__collection-count')?.textContent?.trim() || '',
    }));

    const products = Array.from(els.defaultPanel.querySelectorAll('.ff-search-popup-product__row')).map(
      (link) => ({
        title: link.querySelector('.ff-search-popup-product__title')?.textContent?.trim() || '',
        url: link.getAttribute('href') || '',
        image: link.querySelector('img')?.getAttribute('src') || '',
        vendor: link.querySelector('.ff-search-popup-product__vendor')?.textContent?.trim() || '',
        price: link.querySelector('.ff-search-popup-product__price')?.textContent?.trim() || '',
        priceFormatted: true,
      })
    );

    return { collections, products };
  }

  function filterByQuery(items, query) {
    const q = query.toLowerCase();
    return items.filter((item) => item.title?.toLowerCase().includes(q));
  }

  function getInstantResults(query) {
    const defaults = getDefaultItems();
    return {
      collections: filterByQuery(defaults.collections, query),
      products: filterByQuery(defaults.products, query),
    };
  }

  function syncPopupPosition() {
    if (!popup) return;

    const header =
      document.querySelector('.section-header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('.header');

    if (!header) return;

    const gap = window.innerWidth >= 990 ? 6 : 4;
    const headerBottom = header.getBoundingClientRect().bottom;
    const panel = popup.querySelector('.ff-search-popup__panel');

    popup.style.top = `${headerBottom + gap}px`;

    if (panel) {
      panel.style.maxHeight = `${window.innerHeight - headerBottom - gap - 12}px`;
    }
  }

  function resetPopupPosition() {
    if (!popup) return;
    popup.style.top = '';
    const panel = popup.querySelector('.ff-search-popup__panel');
    if (panel) panel.style.maxHeight = '';
  }

  function openPopup(container) {
    if (!container || !queryElements()) return;

    portalRoot();

    activeContainer = container;
    activeInput = container.querySelector('input[type="search"]');

    openSearchDetails(container);

    scrim.classList.add('is-open');
    scrim.setAttribute('aria-hidden', 'false');
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    container.classList.add('header__search--popup-open');
    document.body.classList.add('ff-search-open');
    lockPageScroll();

    const query = activeInput?.value.trim() || '';
    if (query) {
      handleSearchInput(query, true);
    } else {
      showDefaultView();
    }

    syncPopupPosition();

    window.requestAnimationFrame(() => {
      syncPopupPosition();
      activeInput?.focus({ preventScroll: true });
    });
  }

  function closePopup() {
    if (!popup?.classList.contains('is-open')) return;

    const container = activeContainer;

    scrim?.classList.remove('is-open');
    scrim?.setAttribute('aria-hidden', 'true');
    root?.classList.remove('is-open');
    root?.setAttribute('aria-hidden', 'true');
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ff-search-open');

    container?.classList.remove('header__search--popup-open');

    if (debounceTimer) {
      clearTimeout(debounceTimer);
      debounceTimer = null;
    }

    if (abortController) {
      abortController.abort();
      abortController = null;
    }

    resetPopupPosition();
    showDefaultView();
    activeInput = null;
    closeSearchDetails(container);
    activeContainer = null;
    unlockPageScroll();
  }

  function renderCollection(item, query) {
    const image = item.featured_image?.url || item.image || '';
    let count = 'Collection';
    if (item.products_count) {
      count = String(item.products_count).includes('Product') ? item.products_count : `${item.products_count} products`;
    }

    return `
      <li>
        <a href="${escapeHtml(item.url)}" class="ff-search-popup__collection-item">
          <span class="ff-search-popup__collection-thumb">
            ${
              image
                ? `<img src="${escapeHtml(image)}" alt="" loading="lazy" width="48" height="48">`
                : `<span class="ff-search-popup__collection-placeholder">${escapeHtml(item.title?.charAt(0) || 'C')}</span>`
            }
          </span>
          <span class="ff-search-popup__collection-info">
            <span class="ff-search-popup__collection-name">${highlightMatch(item.title, query)}</span>
            <span class="ff-search-popup__collection-count">${escapeHtml(count)}</span>
          </span>
          <span class="ff-search-popup__collection-arrow" aria-hidden="true">
            <svg viewBox="0 0 20 20" fill="none"><path d="M7 5l5 5-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
          </span>
        </a>
      </li>
    `;
  }

  function renderProduct(item, query) {
    const image = item.featured_image?.url || item.image || '';
    const vendor = showVendor && item.vendor ? `<span class="ff-search-popup-product__vendor">${escapeHtml(item.vendor)}</span>` : '';
    let priceHtml = '';
    if (showPrice) {
      if (item.priceFormatted && item.price) {
        priceHtml = `<span class="ff-search-popup-product__price">${escapeHtml(item.price)}</span>`;
      } else if (item.price) {
        priceHtml = `<span class="ff-search-popup-product__price">${formatMoney(item.price)}</span>`;
      }
    }

    return `
      <li>
        <a href="${escapeHtml(item.url)}" class="ff-search-popup-product__row">
          <span class="ff-search-popup-product__thumb">
            ${
              image
                ? `<img src="${escapeHtml(image)}" alt="" loading="lazy" width="72" height="72">`
                : `<span class="ff-search-popup-product__thumb-placeholder">?</span>`
            }
          </span>
          <span class="ff-search-popup-product__meta">
            ${vendor}
            <span class="ff-search-popup-product__title">${highlightMatch(item.title, query)}</span>
            ${priceHtml}
          </span>
        </a>
      </li>
    `;
  }

  function renderResults(result, query) {
    const collections = result?.collections || [];
    const products = result?.products || [];

    if (!collections.length && !products.length) {
      if (els.title) els.title.textContent = `No results for "${query}"`;
      setPanel('empty');
      return;
    }

    if (els.title) els.title.textContent = `Results for "${query}"`;

    if (els.collectionsList) {
      els.collectionsList.innerHTML = collections.map((item) => renderCollection(item, query)).join('');
    }
    if (els.productsList) {
      els.productsList.innerHTML = products.map((item) => renderProduct(item, query)).join('');
    }

    els.collectionsWrap?.classList.toggle('is-hidden', collections.length === 0);
    els.productsWrap?.classList.toggle('is-hidden', products.length === 0);

    if (els.viewAll) {
      els.viewAll.href = `${searchUrl}?q=${encodeURIComponent(query)}`;
    }

    setPanel('results');
  }

  function parsePredictiveSearch(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const section = doc.querySelector('#shopify-section-predictive-search') || doc;

    const products = Array.from(
      section.querySelectorAll('#predictive-search-results-products-list .predictive-search__list-item')
    ).map((li) => {
      const link = li.querySelector('a');
      const titleEl = li.querySelector('.predictive-search__item-heading');
      const imgEl = li.querySelector('.predictive-search__image');
      const vendorEl = li.querySelector('.predictive-search__item-vendor');
      const priceEl = li.querySelector('.price');

      return {
        title: titleEl?.textContent?.trim() || '',
        url: link?.getAttribute('href') || '',
        image: imgEl?.getAttribute('src') || '',
        vendor: vendorEl?.textContent?.trim() || '',
        price: priceEl?.textContent?.trim() || '',
        priceFormatted: true,
      };
    });

    const collections = Array.from(section.querySelectorAll('[id^="predictive-search-option-collection-"]')).map(
      (li) => {
        const link = li.querySelector('a');
        const titleEl = li.querySelector('.predictive-search__item-heading');

        return {
          title: titleEl?.textContent?.trim() || '',
          url: link?.getAttribute('href') || '',
          image: '',
        };
      }
    );

    return { products, collections };
  }

  async function fetchSuggestResource(query, type, limit, signal) {
    const resultKey = type === 'product' ? 'products' : 'collections';
    const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=${type}&resources[limit]=${limit}&resources[options][unavailable_products]=last`;
    const response = await fetch(url, { signal });
    if (!response.ok) return [];
    const data = await response.json();
    return data?.resources?.results?.[resultKey] || [];
  }

  async function fetchPredictiveFallback(query, signal) {
    const base = window.routes?.predictive_search_url || '/search/suggest';
    const url = `${base}?q=${encodeURIComponent(query)}&section_id=predictive-search`;
    const response = await fetch(url, { signal });
    if (!response.ok) return { products: [], collections: [] };
    const html = await response.text();
    return parsePredictiveSearch(html);
  }

  async function fetchSuggestions(query) {
    const cacheKey = query.toLowerCase();
    if (cachedResults[cacheKey]) {
      renderResults(cachedResults[cacheKey], query);
      return;
    }

    if (abortController) abortController.abort();
    abortController = new AbortController();
    const signal = abortController.signal;

    try {
      const instant = getInstantResults(query);

      const [apiProducts, apiCollections, fallback] = await Promise.all([
        fetchSuggestResource(query, 'product', 10, signal),
        fetchSuggestResource(query, 'collection', 6, signal),
        fetchPredictiveFallback(query, signal).catch(() => ({ products: [], collections: [] })),
      ]);

      const result = {
        products: mergeByUrl(mergeByUrl(instant.products, apiProducts), fallback.products),
        collections: mergeByUrl(mergeByUrl(instant.collections, apiCollections), fallback.collections),
      };

      cachedResults[cacheKey] = result;
      renderResults(result, query);
    } catch (error) {
      if (error?.name === 'AbortError') return;

      const instant = getInstantResults(query);
      if (instant.collections.length || instant.products.length) {
        renderResults(instant, query);
        return;
      }

      if (els.title) els.title.textContent = `No results for "${query}"`;
      setPanel('empty');
    }
  }

  function handleSearchInput(query, immediate) {
    if (!query.length) {
      showDefaultView();
      return;
    }

    lastQuery = query;

    const instant = getInstantResults(query);
    if (instant.collections.length || instant.products.length) {
      renderResults(instant, query);
    } else {
      setPanel('loading');
      if (els.title) els.title.textContent = `Searching "${query}"…`;
    }

    if (debounceTimer) clearTimeout(debounceTimer);

    if (immediate) {
      fetchSuggestions(query);
    } else {
      debounceTimer = setTimeout(() => {
        if (lastQuery === query) fetchSuggestions(query);
      }, 250);
    }
  }

  function onSearchInput() {
    if (!popup?.classList.contains('is-open') || !activeInput) return;
    handleSearchInput(activeInput.value.trim(), false);
  }

  function onTriggerActivate(event, container) {
    if (event.target.closest('.ff-header-search-bar__submit, .search__button, .reset__button')) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openPopup(container);
  }

  function bindSearch(container) {
    if (container.dataset.ffSearchPopupBound === 'true') return;
    container.dataset.ffSearchPopupBound = 'true';

    const trigger = container.querySelector('summary');
    const input = container.querySelector('input[type="search"]');
    const reset = container.querySelector('.reset__button');

    trigger?.addEventListener('click', (event) => onTriggerActivate(event, container), true);
    input?.addEventListener('focus', () => openPopup(container));
    input?.addEventListener('input', onSearchInput);
    input?.addEventListener('keyup', onSearchInput);

    reset?.addEventListener('click', () => {
      window.setTimeout(() => showDefaultView(), 0);
    });
  }

  function bindGlobalEvents() {
    if (globalBound) return;
    globalBound = true;

    popup?.querySelector('[data-ff-search-close]')?.addEventListener('click', closePopup);
    document.querySelector('[data-ff-search-scrim]')?.addEventListener('click', closePopup);

    document.addEventListener('click', (event) => {
      const activePopup = document.querySelector('[data-ff-search-popup]');
      if (!activePopup?.classList.contains('is-open')) return;
      if (event.target.closest('[data-ff-search-popup]')) return;
      if (event.target.closest('.header__search')) return;
      if (event.target.closest('[data-ff-search-scrim]')) return;
      closePopup();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && popup?.classList.contains('is-open')) {
        event.preventDefault();
        closePopup();
      }
    });

    window.addEventListener('resize', () => {
      if (document.querySelector('[data-ff-search-popup]')?.classList.contains('is-open')) {
        syncPopupPosition();
      }
    });
  }

  function init() {
    if (!queryElements()) return;

    portalRoot();
    bindGlobalEvents();
    document.querySelectorAll('details-modal.header__search').forEach(bindSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
